'use client';

type LoadMoreButtonProps = {
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  fetchNextPage: () => void;
  label: string;
};

export function LoadMoreButton({ hasNextPage, isFetchingNextPage, fetchNextPage, label }: LoadMoreButtonProps) {
  if (!hasNextPage) {
    return null;
  }
  return (
    <button
      type="button"
      className="btn btn-ghost btn-sm w-full mt-2 text-[var(--color-fg-muted)] hover:text-base-content active:!bg-transparent gap-1 [-webkit-tap-highlight-color:transparent]"
      onClick={() => void fetchNextPage()}
      disabled={isFetchingNextPage}
    >
      {isFetchingNextPage ? <span className="loading loading-dots loading-xs" /> : label}
    </button>
  );
}
